import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOffered from './components/ServicesOffered';
import HowItWorks from './components/HowItWorks';
import WhyChoose from './components/WhyChoose';
import CTASection from './components/CTASection';

const NotaryPage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/notary#webpage`,
      url: `${siteUrl}/notary`,
      name: 'Mobile Notary Services | JSJ Burton Enterprises, LLC',
      description:
        'Professional mobile notary services across Northern Illinois — general notarizations, real estate documents, power of attorney, affidavits, and more. Illinois Commissioned Mobile Notary Public.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Notary Services', item: `${siteUrl}/notary` },
        ],
      },
    };
    const scriptId = 'schema-notary';
    let el = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = scriptId;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);
    return () => { const s = document.getElementById(scriptId); if (s) s.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <ServicesOffered />
        <HowItWorks />
        <WhyChoose />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default NotaryPage;
